import { IServiceTrend } from './ICommon';

export enum StaticTableColumns {
	name = 'name',
	responses = 'responses',
	nps = 'nps',
}

export interface ITableService<T> {
	value: T;
	trend?: IServiceTrend;
	serviceId?: number;
	firstVal?: number | null;
	previousVal?: number | null;
	ratingCount?: number | null;
}

export interface ITableRow
	extends Record<
		string,
		ITableService<number | string | null> | ITableRow[] | undefined
	> {
	name: ITableService<string>;
	responses: ITableService<number>;
	nps: ITableService<number | null>;
	statistics: ITableRow[] | undefined;
}
